module.exports = __webpack_public_path__ + "img/shwoImageInfo2.b6ea2ec2.png";